module.exports = __webpack_public_path__ + "static/media/bin.cbf6a743.svg";